/* Me + Lia — Fit Confidence layer (Jul 22 2026, rev 3)
   1) Model line under the fit note — clones the fit note's tag + classes so the
      typography is identical; visible-last-match anchoring so it sits BELOW it
   2) "Find my size" quiz injected into the Size Guide modal (page content untouched)
   3) Result highlights the chart row + marks the recommended pill "our pick"
   rev 2 fixes: (a) "If between sizes, size up" no longer false-triggers the
   runs-small offset — "true to size" wins, only explicit "runs small/large" moves it;
   (b) height now shapes the LENGTH note in the result;
   (c) reason line matches the actual fit copy.
   rev 3: the hand-off line now REPLACES the size-guide page's own "To help you find
   the perfect fit..." intro — one line, one voice. The page itself is NOT edited
   (it is shared store-wide with the live theme); the intro is hidden client-side,
   and only when our line is actually present.
   RULE: never auto-selects a size — marker only (footgun lesson, Jul 19). */
(function () {
  'use strict';
  var SIZES = ['XS', 'S', 'M', 'L', 'XL'];

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var info = document.querySelector('.product__info-container');
    if (!info) return;

    /* ---------- gather per-product fit copy ---------- */
    var fitText = '';
    if (window.mlModelData) {
      try { fitText += (typeof window.mlModelData === 'string' ? window.mlModelData : JSON.stringify(window.mlModelData)) + '\n'; } catch (e) {}
    }
    var accs = document.querySelectorAll('.product__accordion .accordion__content');
    for (var i = 0; i < accs.length; i++) fitText += (accs[i].textContent || '') + '\n';

    /* offset — explicit copy only. "True to size" wins over conditional
       "if between sizes, size up" advice, which is NOT a runs-small signal. */
    var offset = 0;
    var trueToSize = /true to size|fits true/i.test(fitText);
    if (!trueToSize && /runs\s+(slightly\s+)?small/i.test(fitText)) offset = 1;
    else if (!trueToSize && /runs\s+(slightly\s+)?(large|big)/i.test(fitText)) offset = -1;

    /* model reference — used by the model line AND the height/length note */
    var wear = fitText.match(/Model wears size\s*([A-Z]{1,3})\b/i);
    var ht = fitText.match(/Model height:\s*([0-9]\s*'\s*[0-9]{1,2}\s*(?:\"|\u201d)?)/i);
    var htTxt = null;
    if (ht) {
      htTxt = ht[1].replace(/\s+/g, '');
      if (!/(\"|\u201d)$/.test(htTxt)) htTxt += '\u201d';
    }

    /* ---------- 1) model line — same type + classes as the fit note ---------- */
    var anchor = null;
    var cands = info.querySelectorAll('p, div, span');
    for (var c = 0; c < cands.length; c++) {
      var el = cands[c];
      if (el.children.length > 0) continue;
      if (el.closest('.product__accordion') || el.closest('details') || el.closest('.ml-quiz')) continue;
      if (el.offsetParent === null) continue; /* visible elements only */
      var t = (el.textContent || '').trim();
      if (/^Model is/i.test(t)) continue;
      if (t && t.length < 200 && /runs\s+(slightly\s+)?(small|large)|true to size|fits true/i.test(t)) anchor = el; /* keep LAST visible match */
    }
    if (wear && htTxt && !document.querySelector('.ml-model-line')) {
      var line = document.createElement(anchor ? anchor.tagName : 'div');
      line.className = (anchor ? anchor.className + ' ' : '') + 'ml-model-line' + (anchor ? '' : ' ml-model-line--solo');
      line.textContent = 'Model is ' + htTxt + ' and wears a size ' + wear[1].toUpperCase() + '.';
      if (anchor) {
        anchor.insertAdjacentElement('afterend', line);
      } else {
        var picker = info.querySelector('variant-selects');
        if (picker) picker.insertAdjacentElement('beforebegin', line);
      }
    }

    /* ---------- 2) Size Guide button subtitle ---------- */
    var sgBtn = info.querySelector('.ml-size-guide-link');
    if (sgBtn && !sgBtn.querySelector('.ml-fms')) {
      var fms = document.createElement('span');
      fms.className = 'ml-fms';
      fms.textContent = ' \u00b7 Find my size';
      sgBtn.appendChild(fms);
    }

    /* ---------- 3) quiz inside the Size Guide modal ---------- */
    var modal = document.querySelector('.product-popup-modal');
    if (!modal || modal.querySelector('.ml-quiz')) return;
    var host = modal.querySelector('.product-popup-modal__content-info') || modal;

    var quiz = document.createElement('div');
    quiz.className = 'ml-quiz';
    quiz.innerHTML =
      '<p class="ml-quiz__sub">Three quick questions \u2014 or measure yourself below. Your choice.</p>' +
      '<div class="ml-quiz__q">Your height</div>' +
      '<div class="ml-quiz__opts" data-q="h">' +
        '<button type="button" class="ml-quiz__opt" data-v="0">Under 5\u20193\u201d</button>' +
        '<button type="button" class="ml-quiz__opt" data-v="1">5\u20193\u201d\u20135\u20197\u201d</button>' +
        '<button type="button" class="ml-quiz__opt" data-v="2">Over 5\u20197\u201d</button>' +
      '</div>' +
      '<div class="ml-quiz__q">The size you wear in most brands</div>' +
      '<div class="ml-quiz__opts" data-q="s">' +
        '<button type="button" class="ml-quiz__opt" data-v="0">US 2\u20134</button>' +
        '<button type="button" class="ml-quiz__opt" data-v="1">US 6\u20138</button>' +
        '<button type="button" class="ml-quiz__opt" data-v="2">US 10\u201312</button>' +
        '<button type="button" class="ml-quiz__opt" data-v="3">US 14+</button>' +
      '</div>' +
      '<div class="ml-quiz__q">You like your dresses</div>' +
      '<div class="ml-quiz__opts" data-q="f">' +
        '<button type="button" class="ml-quiz__opt" data-v="0">Gently shaped</button>' +
        '<button type="button" class="ml-quiz__opt" data-v="1">Relaxed</button>' +
      '</div>' +
      '<div class="ml-quiz__result" aria-live="polite"></div>';

    var bridge = document.createElement('p');
    bridge.className = 'ml-quiz__bridge';
    bridge.textContent = 'Prefer to check for yourself? The chart and measuring guide below give you the same answer \u2014 you\u2019re most welcome to use them instead.';

    var h1 = host.querySelector('h1');
    if (h1) {
      h1.insertAdjacentElement('afterend', bridge);
      h1.insertAdjacentElement('afterend', quiz);
    } else {
      host.insertAdjacentElement('afterbegin', bridge);
      host.insertAdjacentElement('afterbegin', quiz);
    }

    /* our line supersedes the page's own intro — hide it (page NOT edited) */
    var ps = modal.querySelectorAll('p');
    for (var q = 0; q < ps.length; q++) {
      if (ps[q].classList.contains('ml-quiz__bridge')) continue;
      if (/to help you find the perfect fit/i.test(ps[q].textContent || '')) {
        ps[q].classList.add('ml-sg-intro-hidden');
      }
    }

    var ans = { h: null, s: null, f: null };

    quiz.addEventListener('click', function (e) {
      var btn = e.target.closest('.ml-quiz__opt');
      if (!btn) return;
      var group = btn.parentElement;
      var qq = group.getAttribute('data-q');
      ans[qq] = parseInt(btn.getAttribute('data-v'), 10);
      var sibs = group.querySelectorAll('.ml-quiz__opt');
      for (var j = 0; j < sibs.length; j++) sibs[j].classList.remove('is-sel');
      btn.classList.add('is-sel');
      if (ans.h !== null && ans.s !== null && ans.f !== null) showResult();
    });

    function showResult() {
      /* base follows the chart exactly: US 2\u21924 spans XS/S \u2192 S,
         6\u21928 spans M/L \u2192 M, 10 = XL, 12+ beyond the range \u2192 XL */
      var baseIdx = [1, 2, 4, 4][ans.s];
      var idx = baseIdx + offset + (ans.f === 1 ? 1 : 0);
      var clamped = idx > 4;
      if (idx > 4) idx = 4;
      if (idx < 0) idx = 0;
      var size = SIZES[idx];

      var reasons = [];
      if (offset === 1) reasons.push('this style runs slightly small, so we moved you up one');
      if (offset === -1) reasons.push('this style runs a little large, so we moved you down one');
      if (offset === 0 && trueToSize) reasons.push('this style fits true to size');
      if (ans.f === 1) reasons.push('we added a size for a relaxed fit');

      var html = 'Our pick for you: <b>' + size + '</b>';
      if (clamped) html += ' (the top of our range)';
      if (reasons.length) html += ' \u2014 ' + reasons.join(' and ');
      html += '.';
      if (htTxt && ans.h === 0) html += ' It will fall a little longer on you than on our ' + htTxt + ' model.';
      if (htTxt && ans.h === 2) html += ' It will sit a little shorter on you than on our ' + htTxt + ' model.';
      html += ' Free returns if we got it wrong.';

      var res = quiz.querySelector('.ml-quiz__result');
      res.innerHTML = html;
      res.classList.add('is-on');

      /* highlight the matching chart row */
      var rows = modal.querySelectorAll('.responsive-table tbody tr');
      for (var r = 0; r < rows.length; r++) {
        rows[r].classList.remove('ml-row-pick');
        var first = rows[r].querySelector('td');
        if (first && (first.textContent || '').trim().toUpperCase() === size) rows[r].classList.add('ml-row-pick');
      }

      /* mark the recommended pill — marker only, never select */
      var inputs = info.querySelectorAll('.product-form__input--pill input[type="radio"]');
      for (var p = 0; p < inputs.length; p++) {
        var lab = info.querySelector('label[for="' + inputs[p].id + '"]');
        if (!lab) continue;
        lab.classList.remove('ml-pill-pick');
        if ((inputs[p].value || '').trim().toUpperCase() === size) lab.classList.add('ml-pill-pick');
      }

      try { if (window.clarity) window.clarity('event', 'ml_fit_quiz'); } catch (err) {}
    }
  });
})();

/* ============================================================
   rev 4.2 (Aug 8) — fit-quiz surfacing ROLLED BACK to the styling layer.
   The injected gallery end-card failed phone QA twice (v4: hand-built slide
   box blew the gallery row out into a giant blush void; v4.1: cloned slide
   dragged the zoom-lightbox button along and still rendered oversize /
   stacked). The card is PULLED until it has been browser-QA'd end-to-end
   on the preview theme BEFORE any phone QA. Do not reintroduce it by
   hand-building or blind-cloning — inspect the live mobile gallery DOM
   first and match its exact slide anatomy.
   KEPT (both phone-QA'd fine):
   a) size-guide pill in brand blush/maroon (site tokens #F9EEED / #9B5E5B);
   b) wallet SKIN height 46px to match Add to Bag — .shopify-payment-button
      is our z-overrides skin (label is a CSS ::before), so resizing it never
      touches the wallet's closed-shadow-root internals.
   ============================================================ */
(function () {
  'use strict';
  var css =
    '.shopify-payment-button{height:46px !important;}' +
    '.shopify-payment-button::before{font-size:1.2rem !important;letter-spacing:0.16em !important;}' +
    'body.template-product #MainContent .product__info-container button.ml-size-guide-link,' +
    'body.template-product #MainContent .ml-variant-wrapper button.ml-size-guide-link{' +
    'background:#F9EEED !important;border:1px solid rgba(155,94,91,0.45) !important;' +
    'color:#9B5E5B !important;padding:8px 16px !important;}' +
    '.ml-size-guide-link .ml-fms{color:#9B5E5B !important;font-weight:600 !important;}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);
})();
